//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"CreateShm",1,0],[0,"IsLittleEndian",1,0],[0,"ShmMutex",1,0],[0,"ShmName",1,0]],[[["numSignals"],"GetSHMSignals",{R_:{signalInfos:""}},0,1],[["numSignals"],"GetSHMServerSignals",{R_:{signalInfos:"Mechatronics.GenericServerTagInfo[]"}},0,0],[["signalInfos"],"SetSHMSignals",{},1,1],[["signalInfos"],"SetSHMServerSignals",{},1,0]],[]];
SPLM.Mechatronics.SHMSignalProviderBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SHMSignalProviderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SHMSignalProviderBuilder.SignalInfo = class{
    constructor(signalTag,bChecked,address){
        this.signalTag=signalTag;this.bChecked=bChecked;this.address=address;}
    get Signaltag(){return this.signalTag}
    set Signaltag(val){this.signalTag = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
    get Address(){return this.address}
    set Address(val){this.address = val}
};

export default SPLM;